import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/renthouse/rhWorkOrder/page', data, {
    trim: true
  })
}

// 修改
export function updateById (data) {
  return request.post('/renthouse/rhWorkOrder/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/renthouse/rhWorkOrder/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/renthouse/rhWorkOrder/delete/batch', {
    params: {
      ids
    }
  })
}
